import { Component, EventEmitter, OnDestroy, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, NavigationExtras, Router } from "@angular/router";
import { AirbnbService } from "@core/services/airbnb.service";
import { RequestService } from "@core/services/request.service";
import { environment } from "@env/environment";
import { Agency, Company, Config, User } from "@models";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Store } from "@ngrx/store";
import { TranslateService } from "@ngx-translate/core";
import {
  AgencyService,
  AuthService,
  BookedService,
  CarService,
  CompanyService,
  ConfigService,
  ExpensesService,
  FlightService,
  GroupService,
  LanguageService,
  MediaService,
  NgxToastrService,
  TrainService,
  TravelUtilsService,
  UserService,
  UtilsService,
} from "@services";
import { DialogUserFilesComponent } from "@shared/component/dialog-user-files/dialog-user-files.component";
import { AppState } from "app/app.reducer";
import { SendEmailUsersComponent } from "app/modules/businessEntities/user/send-email-users/send-email-users.component";
import { CreateAirbnbComponent } from "app/modules/components/airbnb/custom/create-airbnb/create-airbnb.component";
import { CreateCarComponent } from "app/modules/components/cars/custom/create-car/create-car.component";
import { CarRequestComponent } from "app/modules/components/custom-services/components/car-request/car-request.component";
import { ExpensesComponent } from "app/modules/components/expenses/expenses.component";
import { CreateFlightTrainComponent } from "app/modules/components/flight-train/create-flight-train/create-flight-train.component";
import { FormFlightTrainComponent } from "app/modules/components/flight-train/form-flight-train/form-flight-train.component";
import { GraphComponent } from "app/modules/components/graph/graph/graph.component";
import { ResetFiltersAction } from "app/store/actions/search.actions";
import * as lodash from "lodash-es";
import * as momentTz from "moment-timezone";
import * as moment from 'moment';
import { forkJoin, Subscription } from "rxjs";
import { take } from "rxjs/operators";
import swal from "sweetalert2";
import { RequestCustomHotelComponent } from "../../../components/custom-services/components/request-custom-hotel/request-custom-hotel.component";
import { ViewPdfModalComponent } from "../../user/user-detail/view-pdf-modal/view-pdf-modal.component";
import { UserFormGroupComponent } from "../../user/user-form-group/user-form-group.component";
import { CreateCustomHotelComponent } from "./../../../components/hotel/create-custom-hotel/create-custom-hotel.component";
import { DepartmentFormComponent } from "app/modules/components/department/department-form/department-form.component";
import { PoliciesModalComponent } from "app/modules/components/policies/policies-modal/policies-modal.component";
import { ImportUsersComponent } from "../../user/import-users/import-users.component";

@Component({
  selector: "app-company-detail",
  templateUrl: "./company-detail.component.html",
  styleUrls: ["./company-detail.component.scss"],
})
export class CompanyDetailComponent implements OnInit, OnDestroy {
  userOrEmployee: User | Company | Agency;
  isGroupAdmin = false;
  company: Company;
  isAmadeusEnabled = environment.AMADEUS_ENABLED === 0 ? false : true;
  departments: any[] = [];
  uuid: string;
  subscription: Subscription[] = [];
  companySubscription: Subscription;
  groupSubscription: Subscription;
  isCompany = false;
  reloadCompanies = new EventEmitter();
  isAdmin = false;
  configHotels: Config;
  configFlights: Config;
  getConfigsubscription: Subscription[] = [];
  maxHotelPercentage;
  maxFlightPercentage;
  image: any;
  agencyImage = "";
  userType: string;
  agency: Agency;
  agenyPhone = "";
  agencyShow: Boolean = false;
  VYOOTRIP_NUMBER = "648 200 516";
  vyooLogo = "../../../../../assets/img/logo/text_logo_new.png";
  trUserName: string;
  trUserLastName: string;
  trGroupName: string;
  params: any = {};
  userName: string;
  userSurname: string;
  hasCleared = false;
  canLoadFilters = false;
  isSuperAdmin = false;
  companyUuid: string;
  pagination: any;
  authorizations: any[] = [];
  type: "booking" | "flight" | "train" | "all";
  status: "request" | "denied" | "accepted" | "no vacancy" | "all";
  page: number;
  haveRequest: Boolean = false;
  planData: any;
  nameFilters;
  typeFilters: any[];
  filter = "";
  userUuid: string;
  totalAuthorizations = 0;
  totalRequests = 0;
  requests: any;
  user: any;
  departmentsCopy: any[] = [];
  allLoaded = false;
  totalUsers = 0;
  totalImages = 0;
  hasNoImage = true;
  fiscalYears = [];
  yearSelected = "";
  emailsGroupInvites: any;
  usersEmailsGroups: string[] = [];
  showContent = true;
  loading = false;
  constructor(
    private companyService: CompanyService,
    private groupService: GroupService,
    private userService: UserService,
    private flightService: FlightService,
    private trainService: TrainService,
    private utilsService: UtilsService,
    private mediaService: MediaService,
    private configService: ConfigService,
    private translateService: TranslateService,
    private ngxToastrService: NgxToastrService,
    private travelUtilsService: TravelUtilsService,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    public translate: TranslateService,
    private router: Router,
    private store: Store<AppState>,
    private expenseService: ExpensesService,
    private agencyService: AgencyService,
    private bookedService: BookedService,
    private langService: LanguageService,
    private carService: CarService,
    public authService: AuthService,
    private dialog: MatDialog,
    private requestService: RequestService,
    private airbnbService: AirbnbService
  ) {}

  ngOnInit() {
    this.typeFilters = ["string"];
    this.nameFilters = ["string"];
    this.page = 1;
    this.status = "request";
    this.type = "all";

    this.params["type"] = this.type;
    this.params["status"] = this.status;

    this.subscription.push(
      this.store.select("auth").subscribe((authState: any) => {
        if (!authState?.user) {
          return;
        }

        this.userUuid = authState.user.uuid;
        this.user = authState.user;
        this.userType = authState.user.type;

        this.uuid = this.route.snapshot.paramMap.get("uuid");

        if (!this.uuid) {
          this.uuid = authState.user?.company?.uuid;
        }

        this.isCompany = this.userType?.toUpperCase() === "COMPANY";

        const isAdminType =
          this.userType?.toUpperCase() === "EMPLOYEE" ||
          this.userType?.toUpperCase() === "HUB" ||
          this.userType?.toUpperCase() === "AGENCY";

        if (isAdminType) {
          this.isAdmin = true;
          this.getPercentages();
        }

        if (this.userType?.toUpperCase() === "EMPLOYEE") {
          this.isSuperAdmin = true;
        }

        if (this.uuid) {
          this.loadCompany(this.uuid);
          this.loadGroups(this.uuid);

          this.getAuthorizationList();
          this.getRequestList();
        }
      })
    );

    this.getTranslations();
    this.reloadCompanies.subscribe(() => this.loadCompany(this.uuid));
  }

  /**
   * Method triggered when a filter field changes. If it is an INPUT field, it calls our subject.
   * If it is not, it calls directly to our updateParams method and to the API caller method
   * @param param field name
   * @param event field value
   * @see updateParams()
   * @see getAuthorizationList()
   */
  filterParam(event?) {
    this.filter = event;
  }

  /**
   * Return all years that has passed from the company signup in Vyootrip
   */
  getFiscalYears() {
    const currentYear = new Date().getFullYear();
    let startYear = new Date(this.company.createdAt).getFullYear();
    while (startYear <= currentYear) {
      this.fiscalYears.push(startYear++);
    }
    this.fiscalYears.reverse();
  }

  /**
   * Clears the params object and call the API service with no params
   */
  clearFilters() {
    this.params = {};

    this.hasCleared = true;
  }
  ngOnDestroy() {
    this.subscription.forEach((s) => s.unsubscribe());
    if (this.companySubscription) {
      this.companySubscription.unsubscribe();
    }
    if (this.groupSubscription) {
      this.groupSubscription.unsubscribe();
    }
  }
  /**
   * With this method, we get the translations for placeholders in html templates, and the status options array
   */
  getTranslations() {
    this.subscription.push(
      this.translateService
        .get([
          "authorization.labels.name",
          "authorization.labels.lastName",
          "authorization.labels.group",
        ])
        .pipe(take(1))
        .subscribe((result) => {
          // labels in html filters
          this.trUserName = result["authorization.labels.name"];
          this.trUserLastName = result["authorization.labels.lastName"];
          this.trGroupName = result["authorization.labels.group"];
          this.canLoadFilters = true;
        })
    );
  }

  loadCompany(uuid: string) {
    this.companySubscription = this.companyService.getCompany(uuid).subscribe(
      (company: Company) => {
        this.company = company;
        this.utilsService.storeParamInLocalStorage({
          title: "companyUuid",
          value: this.company.uuid,
        });
        this.getFiscalYears();
        if (this.authService.isAdmin()) {
          this.subscription.push(
            this.authService
              .getCompanyPlan(this.company.uuid)
              .subscribe((planRes) => {
                this.authService.userCompanyPlan = planRes;
                const cardData =
                  company.cardData != null &&
                  company.cardData.digitsCard != null &&
                  company.cardData.digitsCard !== "" &&
                  company.cardData.digitsCard !== " ";
                const bookedWithoutCard = company.bookedWithoutCard
                  ? true
                  : false;
                const companyStorage = {
                  hasCard: cardData,
                  allowBookingWithoutCard: bookedWithoutCard,
                  allowBookingRequest:
                    this.authService.userCompanyPlan.permissions
                      .canCreateBookingRequest,
                  canRequestWithoutCard:
                    planRes.permissions.canRequestWithoutCard,
                };
                this.utilsService.storeParamInLocalStorage({
                  title: "company",
                  value: companyStorage,
                });
              })
          );
        }
        if (this.company.image) {
          this.subscription.push(
            this.mediaService.getMedia(this.company.image).subscribe(
              (s) => {
                const reader = new FileReader();
                reader.readAsDataURL(s);
                let base64data;
                reader.onloadend = () => {
                  base64data = reader.result;
                  this.image = base64data;
                };
              },
              (err) => {
                this.translate
                  .get("company.company-detail.error-get-company")
                  .pipe(take(1))
                  .subscribe((result) => {
                    this.ngxToastrService.typeInfo(result, err.error.error);
                  });
              }
            )
          );
        }
        if (this.company.agencyUuid) {
          this.subscription.push(
            this.agencyService
              .getPhone(this.company.agencyUuid)
              .subscribe((p) => {
                this.agenyPhone = p;
              }),
            this.agencyService.getAgency(this.company.agencyUuid).subscribe(
              (i) => {
                this.agencyImage = i.image;
                if (this.agencyImage) {
                  this.subscription.push(
                    this.mediaService
                      .getMedia(this.agencyImage)
                      .subscribe((s) => {
                        this.agencyShow = true;
                        const reader = new FileReader();
                        reader.readAsDataURL(s);
                        let base64data;
                        reader.onloadend = () => {
                          base64data = reader.result;
                          this.agencyImage = base64data;
                        };
                      })
                  );
                } else {
                  this.agenyPhone = this.VYOOTRIP_NUMBER;
                  this.agencyShow = true;
                  this.agencyImage = this.vyooLogo;
                }
              },
              (err) => {
                this.translate
                  .get("company.company-detail.error-get-company")
                  .pipe(take(1))
                  .subscribe((result) => {
                    this.ngxToastrService.typeInfo(result, err.error.error);
                  });
              }
            )
          );
        } else {
          this.agencyShow = true;
          this.agencyImage = this.vyooLogo;
          this.agenyPhone = this.VYOOTRIP_NUMBER;
        }
      },
      (err) => {
        this.translate
          .get("company.company-detail.error-get-company")
          .pipe(take(1))
          .subscribe((result) => {
            this.ngxToastrService.typeInfo(result, err.error.error);
          });
      }
    );
  }

  loadGroups(uuid: string, year?: number) {
    this.loading = true;
    this.allLoaded = false;
    if (year) {
      this.params.filterByYears = year;
      this.yearSelected = year.toString();
    } else {
      delete this.params.filterByYears;
      this.yearSelected = "";
    }
    this.groupSubscription = this.groupService
      .getGroups(uuid, this.params)
      .pipe(take(1))
      .subscribe(
        (departments: any[]) => {
          this.departments = this.utilsService.sortArrayByDate(departments).reverse();
          this.departments.forEach((g) => {
            if (g.users.length > 0) {
              g.users.forEach(async (u) => {
                this.usersEmailsGroups.push(u.email);
                this.totalUsers++;
                if (u.image) {
                  this.hasNoImage = false;
                }
                await this.getUserProfilePicture(u);
              });
            }
          });

          /* this.groups = groups; */
          this.departments.map((g) => {
            if (g.name === "Default") {
              if (this.langService.getLanguage() === "es") {
                g.name = "No asignado";
              }
              const index = this.departments.indexOf(g);
              this.departments.splice(index, 1);
              this.departments.push(g);
            }
          });
          this.departmentsCopy = this.departments;
          this.loading = false;
          this.loadEmailsGroupInvites(this.company.uuid)
        },
        (err) => {
          this.translate
            .get("company.company-detail.error-get-groups")
            .pipe(take(1))
            .subscribe((result) => {
              this.ngxToastrService.typeInfo(result, err);
            });
        }
      );
  }


  loadEmailsGroupInvites(companyUuid: string){
    this.loading = true;

    this.groupSubscription = this.companyService.getEmailGroupsByCompany(companyUuid)
      .subscribe(res => {
        this.emailsGroupInvites = res;
        this.emailsGroupInvites = this.emailsGroupInvites?.filter(invite => !this.usersEmailsGroups?.includes(invite.email)) || null;
        this.loading = false;
      },
      (err) => {
        this.translate
          .get("company.company-detail.error-get-groups")
          .pipe(take(1))
          .subscribe((result) => {
            this.ngxToastrService.typeInfo(result, err);
          });
      })
  }


  onNewGroup() {
    if (
      this.authService.isAdmin() ||
      this.authService.userCompanyPlan.permissions.canCreateUnlimitedGroups ===
        -1 ||
      this.departments.length + 1 <=
        this.authService.userCompanyPlan.permissions.canCreateUnlimitedGroups
    ) {
      const modalRef = this.modalService.open(DepartmentFormComponent, {
        size: "md",
        centered: true,
        backdrop: "static",
      });

      modalRef.componentInstance.company = this.company;
      modalRef.componentInstance.isCreateDepartment = true;
      modalRef.result.then((createdDepartment) => {
        if (createdDepartment) {
          this.loadGroups(this.company.uuid);
        }
      }).catch(() => {});

      // const modalRef = this.modalService.open(GroupFormComponent, {
      //   size: "lg",
      //   centered: true,
      // });
      // modalRef.componentInstance.loading = false;
      // modalRef.componentInstance.company = this.company;
      // modalRef.componentInstance.sendInfo.subscribe((groupInfo) => {
      //   const companyUuid = groupInfo.company.uuid;
      //   delete groupInfo.company;
      //   modalRef.componentInstance.loading = true;
      //   this.groupService.postGroup(companyUuid, groupInfo).subscribe(
      //     () => {
      //       modalRef.componentInstance.loading = false;
      //       modalRef.dismiss("Send Info");
      //       this.translate
      //         .get("company.company-detail.created-group")
      //         .subscribe((result) => {
      //           this.ngxToastrService.typeSuccess(null, result);
      //         });
      //       this.loadGroups(this.company.uuid);
      //     },
      //     (err) => {
      //       modalRef.componentInstance.loading = false;
      //       this.translate
      //         .get("company.company-detail.error-create-group")
      //         .subscribe((result) => {
      //           this.ngxToastrService.typeInfo(result, err.error.message);
      //         });
      //     }
      //   );
      // });
    } else if (
      this.departments.length ===
      this.authService.userCompanyPlan.permissions.canCreateUnlimitedGroups
    ) {
      this.translate
        .get("company.company-detail.create-group-limit")
        .subscribe((result) => {
          this.ngxToastrService.typeInfo(null, result);
        });
    }
  }

  onEditGroup(group: any) {
    const modalRef = this.modalService.open(DepartmentFormComponent, {
        size: "md",
        centered: true,
        backdrop: "static",
      });

      modalRef.componentInstance.company = this.company;
      modalRef.componentInstance.isCreateDepartment = false;
      modalRef.componentInstance.department = group;
      modalRef.result.then((updatedDepartment) => {
        if (updatedDepartment) {
          this.loadGroups(this.company.uuid);
        }
      }).catch(() => {});

    // const modalRef = this.modalService.open(GroupFormComponent, {
    //       size: "lg",
    //       centered: true,
    //     });
    //     modalRef.componentInstance.loading = false;
    //     modalRef.componentInstance.group = group;
    //     modalRef.componentInstance.company = this.company;

    //   modalRef.componentInstance.sendInfo.subscribe((groupInfo) => {
    //       groupInfo.uuid = group.uuid;
    //   modalRef.componentInstance.loading = true;
    //   this.groupService.putGroup(this.company.uuid, groupInfo).subscribe(
    //     () => {
    //       modalRef.componentInstance.loading = false;
    //       modalRef.dismiss("Send Info");
    //       this.translate
    //         .get("company.company-detail.edit-group-succesful")
    //         .subscribe((result) => {
    //           this.ngxToastrService.typeSuccess(null, result);
    //         });
    //       this.loadGroups(this.company.uuid);
    //     },
    //     (err) => {
    //       modalRef.componentInstance.loading = false;
    //       this.translate
    //         .get("company.company-detail.error-create-group")
    //         .subscribe((result) => {
    //           this.ngxToastrService.typeInfo(result, err.error.message);
    //         });
    //     }
    //   );
    // });
  }

  onNewExpense(groupUuid: string, userUuid: string) {
    const modalRef = this.modalService.open(ExpensesComponent, {
      size: "lg",
      centered: true,
      backdrop: "static",
      keyboard: false,
    });
    modalRef.componentInstance.userUuid = userUuid;
    modalRef.componentInstance.departmentUuid = groupUuid;
    modalRef.componentInstance.companyUuid = this.company.uuid;
    modalRef.componentInstance.sendInfo.subscribe((body) => {
      const formData = new FormData();
      if(body.file){
        if (body.file && Array.isArray(body.file)) {
          body.file.forEach((file: any, index: number) => {
            if (file.blob && file.name) {
              const newFile = new File([file.blob], file.name, { type: file.blob.type });
              formData.append("file", newFile, newFile.name);
            } 
            else if (file instanceof File) {
              formData.append("file", file, file.name);
            } 
            else if (file instanceof Blob) {
              const newFile = new File([file], `file_${index}.pdf`, { type: file.type });
              formData.append("file", newFile, newFile.name);
            } 
          });
        } 
      }
      formData.append("departmentUuid", body.departmentUuid);
      formData.append("companyUuid", body.companyUuid);
      formData.append("userUuid", body.userUuid);
      formData.append("price", body.price);
      formData.append("beginDate", body.beginDate);
      formData.append("endDate", body.endDate);
      formData.append("type", body.type);
      formData.append("newCustom", "true");
      formData.append("customCode", body.customCode);
      formData.append("costCenter", body.costCenter);
      if(body.supplierInvoice) {
        formData.append("supplierInvoice", body.supplierInvoice);
      }
      if(body.bookType) {
        formData.append("bookType", body.bookType);
      }
      if(body.invoiced) {
        formData.append("invoiced", body.invoiced);
      }
      if (body.comments) {
        formData.append("comments", body.comments);
      }
      if (body.adminComments) {
        formData.append("adminComments", body.adminComments);
      }
      if (body.annotationsExtras) {
        formData.append("annotationsExtras", body.annotationsExtras);
      }
      formData.append("freeTaxes", body.freeTaxes);
      if (body.providerUuid) {
        formData.append("providerUuid", body.providerUuid);
      }
      if(body.wholesalePrice){
        formData.append("wholesalePrice", body.wholesalePrice);
      }
      if (body.travelName) {
        formData.append("travelName", body.travelName);
      }
      if(body.paymentCard){
        formData.append("paymentCard", JSON.stringify(body.paymentCard));
      }
      const fte = {
        departDate: body.beginDate,
        returnDate: body.endDate,
        oneWay: false,
      };

      if (this.checkTravelAndBookDates(fte)) {
        this.expenseService.createExpense(formData).subscribe(
          (expense) => {
            this.translate.get("expenses.success").subscribe((result) => {
              this.ngxToastrService.typeSuccess(null, result);
              this.handleTravelFlow(expense, "expense", userUuid);
            });
            modalRef.componentInstance.loading = false;
            modalRef.dismiss();
            // if (this.hasPdf(expense, "expense")) {
            //   this.onGetPDF(expense);
            // } 
            const route = this.utilsService.getNavigationRoute(this.user, this.company);
            if (route) {
              this.router.navigate([route]);
            }
          },
          (err) => {
            modalRef.componentInstance.loading = false;

            const errorBody = err?.error || {};
            const validationErrors = Array.isArray(errorBody.validationErrors)
              ? errorBody.validationErrors
              : [];

            if (err.status === 422 && validationErrors.length > 0) {
              const validationMessage = this.utilsService.getValidationErrorsMessage(
                validationErrors,
                'expense'
              );

              if (typeof modalRef.componentInstance.applyBackendValidationErrors === 'function') {
                modalRef.componentInstance.applyBackendValidationErrors(validationErrors);
              }

              this.ngxToastrService.typeInfo(
                'ERROR',
                validationMessage || errorBody.message || this.translate.instant('common.validation.form-invalid'),
                10000,
                { enableHtml: true }
              );

              return;
            }

            modalRef.close();

            this.ngxToastrService.typeInfo(
              'ERROR',
              errorBody.message ? errorBody.message : errorBody.text
            );
          }
        );
      } else {
        modalRef.componentInstance.loading = false;
      }
    });
  }

  openGraphModal(name, type, graphic, uuid) {
    const modalRef = this.modalService.open(GraphComponent, {
      size: "lg",
      centered: true,
    });
    modalRef.componentInstance.name = name;
    modalRef.componentInstance.type = type;
    modalRef.componentInstance.graphic = graphic;
    if (uuid) {
      modalRef.componentInstance.uuid = uuid;
    }
  }

  onDeleteGroup(group: any) {
    if (group.name === "No asignado" || group.name === "Default") {
      this.translate.get("common.cannot-delete-group").subscribe((result) => {
        this.ngxToastrService.typeInfo(result, "");
      });
    } else {
      this.translate
        .get([
          "company.company-detail.remove-group",
          "company.company-detail.group-data-lost",
          "common.confirm",
          "common.cancel",
          "company.company-detail.group-removed",
          "company.company-detail.error-removed-group",
        ])
        .subscribe((result) => {
          swal
            .fire({
              title: result["company.company-detail.remove-group"],
              text: result["company.company-detail.group-data-lost"],
              showCancelButton: true,
              confirmButtonColor: "#0CC27E",
              cancelButtonColor: "#FF586B",
              confirmButtonText: result["common.confirm"],
              cancelButtonText: result["common.cancel"],
              customClass: {
                confirmButton: "swal-button-squared swal-button-confirm-green",
                cancelButton: "swal-button-squared swal-button-dismiss-red",
              },
              buttonsStyling: false,
            })
            .then((action) => {
              if (action.value) {
                this.groupService
                  .deleteGroup(this.company.uuid, group.uuid)
                  .subscribe(
                    () => {
                      this.ngxToastrService.typeSuccess(
                        null,
                        result["company.company-detail.group-removed"]
                      );
                      this.totalUsers = 0;
                      this.totalImages = 0;
                      this.hasNoImage = true;
                      this.allLoaded = false;
                      this.loadGroups(this.company.uuid);
                    },
                    (err) => {
                      this.ngxToastrService.typeInfo(
                        result["company.company-detail.error-removed-group"],
                        err.error.message
                      );
                    }
                  );
              }
            });
        });
    }
  }

  onNewUser() {
    const navigationUser: NavigationExtras = {
      state: {
        loading: false,
        company: this.company,
        fromCompanyDetails: true,
        externalUser: this.user,
      },
    };

    this.router.navigate(["user/create-user"], navigationUser);
    /*const modalRef = this.modalService.open(UserFormComponent, {
      size: "lg",
      centered: true,
    });
    modalRef.componentInstance.loading = false;
    modalRef.componentInstance.company = this.company;
    modalRef.componentInstance.fromCompanyDetails = true;
    modalRef.componentInstance.sendInfo.subscribe((userInfo) => {
      modalRef.componentInstance.loading = true;
      const groupRestrictionUuid = userInfo.group.uuid;
      delete userInfo.group;
      userInfo.groupRestrictionUuid = groupRestrictionUuid;
      userInfo.companyUuid = this.company.uuid;
      this.userService.postUser(userInfo).subscribe(
        () => {
          modalRef.componentInstance.loading = false;
          modalRef.dismiss("Send Info");
          this.translate
            .get("company.company-detail.user-email-pass")
            .subscribe((result) => {
              this.ngxToastrService.typeSuccess(null, result);
            });
          this.translate
            .get("company.company-detail.created-user")
            .subscribe((result) => {
              this.ngxToastrService.typeSuccess(null, result);
            });
          this.loadGroups(this.company.uuid);
        },
        (err) => {
          modalRef.componentInstance.loading = false;
          this.translate
            .get("company.company-detail.error-created-user")
            .subscribe((result) => {
              this.ngxToastrService.typeInfo(result, err.error.message);
            });
        }
      );
    });*/
  }

  onImportUsers(): void {
    const modalRef = this.modalService.open(ImportUsersComponent, {
      size: "lg",
      centered: true,
      backdrop: "static",
      keyboard: false,
    });

    modalRef.componentInstance.company = this.company;
    modalRef.componentInstance.departments = this.departments;
    modalRef.componentInstance.authorUuid = this.userUuid;

    modalRef.result
      .then((result) => {
        if (result?.imported > 0) {
          this.totalUsers = 0;
          this.totalImages = 0;
          this.hasNoImage = true;
          this.allLoaded = false;
          this.loadGroups(this.company.uuid);
        }
      })
      .catch(() => {});
  }

  onExternalUser(department?: any) {
    const modalRef = this.modalService.open(SendEmailUsersComponent, { centered: true });
    modalRef.componentInstance.loading = false;
    modalRef.componentInstance.departments = department ? null : this.departments;
    modalRef.componentInstance.companyData = this.company;
    modalRef.componentInstance.userData = this.user;
    this.companyService.getPoliciesCompany(this.uuid).subscribe(
      (policies) => {
        modalRef.componentInstance.policies = Array.isArray(policies) ? policies : [];
      },
      () => {
        modalRef.componentInstance.policies = [];
      }
    );

    modalRef.componentInstance.sendInfo.subscribe(
      (data) => {
        modalRef.componentInstance.loading = true;
        const body = {
          emailList: data.emails,
          companyUuid: this.uuid,
          departmentUuid: data.group ? data.group : department?.uuid,
          userUuid: this.userUuid,
          accessType: data.accessType,
          authorUuid: this.userUuid,
          policyUuid: data.policy || null,
          notifications: data.notifications
        };

        this.userService.sendEmailsExternalUsers(body).subscribe(
          (res) => {
            modalRef.componentInstance.loading = false;
            modalRef.dismiss();
            this.translate
              .get([
                "common.understood",
                "company.company-detail.user-external.email-pass",
                "company.company-detail.user-external.subtitle",
              ])
              .subscribe((result) => {
                swal
                  .fire({
                    html: `<div id="understood-container" style="display: flex; flex-direction: column"><p>${result["company.company-detail.user-external.subtitle"]}</p><img data-enlargeable src="assets/img/examples/trm/user-enabled.png" alt="Imagen ejemplo de usuario habilitado"/></div>`,
                    allowOutsideClick: false,
                    confirmButtonText: result["common.understood"],
                    title: result["company.company-detail.user-external.email-pass"],
                  })
                  .then(() => this.loadGroups(this.company.uuid));
              });
          },
          (err) => {
            modalRef.componentInstance.loading = false;
            if (err?.error?.code === 'USER_ALREADY_EXISTS') {
              this.translate
                .get([
                  'company.company-detail.error-invited-user',
                  'user.notifications.already-exists'
                ])
                .subscribe((result) => {
                  this.ngxToastrService.typeInfo(
                    result['company.company-detail.error-invited-user'],
                    `${result['user.notifications.already-exists']} ${err.error.email}`
                  );
                });

              return;
            }
            this.translate.get("company.company-detail.error-created-user").subscribe((result) => {
              this.ngxToastrService.typeInfo(result, err?.error?.message);
            });
          }
        );
      },
      (err) => {
        modalRef.componentInstance.loading = false;
        this.translate.get("company.company-detail.error-created-user").subscribe((result) => {
          this.ngxToastrService.typeInfo(result, err?.error?.message);
        });
      }
    );
  }

  resendEmailRegister(emailGroup: any){
    this.loading = true;

    const body = {
      emailList: [emailGroup.email],
      companyUuid: emailGroup.companyUuid,
      departmentUuid: emailGroup.departmentUuid,
      authorUuid: this.userUuid
    };

    this.userService.sendEmailsExternalUsers(body).subscribe(
      (res) => {
        this.loading = false;
        this.translate
          .get([
            "common.understood",
            "company.company-detail.user-external.email-pass",
            "company.company-detail.user-external.subtitle",
          ])
          .subscribe((result) => {
            swal
              .fire({
                html: `<div id="understood-container" style="display: flex; flex-direction: column"><p>${result["company.company-detail.user-external.subtitle"]}</p><img data-enlargeable src="assets/img/examples/trm/user-enabled.png" alt="Imagen ejemplo de usuario habilitado"/></div>`,
                allowOutsideClick: false,
                confirmButtonText: result["common.understood"],
                title:
                  result["company.company-detail.user-external.email-pass"],
              })
          });
      },
      (err) => {
        this.translate
          .get("company.company-detail.error-created-user")
          .subscribe((result) => {
            this.ngxToastrService.typeInfo(result, err.error.message);
          });
      });
  }

  onDeleteEmailInvitation(invitation: any){
    this.translate
      .get([
        "common.delete-invitation",
        "common.confirm",
        "common.cancel",
        "common.deleted-invitation",
        "common.deleted-invitation-error",
      ])
      .subscribe((result) => {
        swal
          .fire({
            title: result["common.delete-invitation"],
            showCancelButton: true,
            confirmButtonColor: "#10B981",
            cancelButtonColor: "#ED5A46",
            confirmButtonText: result["common.confirm"],
            cancelButtonText: result["common.cancel"],
            customClass: {
              confirmButton: "swal-button-squared swal-button-confirm-green",
              cancelButton: "swal-button-squared swal-button-dismiss-red",
            },
            buttonsStyling: false,
          })
          .then((action) => {
            if (action.value) {
              this.loading = true;
              this.companyService.deleteInvitation(invitation.email, invitation.companyUuid)
                  .subscribe(res => {
                    this.ngxToastrService.typeSuccess(
                      null,
                      result["common.deleted-invitation"]
                    );
                    this.loading = false;
                    this.loadGroups(this.companyUuid)
                  },(err) => {
                    this.ngxToastrService.typeInfo(
                      result["common.deleted-invitation-error"],
                      err.error.message
                    );
                  })
            }});
          });
  }

  onEditUserGroup(user: User, group: any) {
    this.userService.getPoliciesUser(user.uuid).subscribe((policies) => {
      const modalRef = this.modalService.open(UserFormGroupComponent, {
        centered: true,
      });
      modalRef.componentInstance.loading = false;
      modalRef.componentInstance.company = this.company;
      modalRef.componentInstance.department = group;
      modalRef.componentInstance.user = user;
      modalRef.componentInstance.travelPolicies = policies;

      modalRef.componentInstance.sendInfo.subscribe((userInfo) => {
        modalRef.componentInstance.loading = true;
        const departmentUuid = userInfo.group.uuid;
        delete userInfo.group;
        userInfo.departmentUuid = departmentUuid;
        this.userService.putUserGroup(user.uuid, userInfo).subscribe(
          () => {
            modalRef.componentInstance.loading = false;
            modalRef.dismiss("Send Info");
            this.translate.get("company.company-detail.user-edit").subscribe((result) => {
              this.ngxToastrService.typeSuccess(null, result);
            });
            this.loadGroups(this.company.uuid);
          },
          (err) => {
            modalRef.componentInstance.loading = false;
            this.translate.get("company.company-detail.error-user-edit").subscribe((result) => {
              this.ngxToastrService.typeInfo(result, err.error.message);
            });
          }
        );
      });
    });
  }

  onEditUser(user: User, group: any) {
    /*const modalRef = this.modalService.open(UserFormComponent, {
      size: "lg",
      centered: true,
    });
    modalRef.componentInstance.loading = false;
    modalRef.componentInstance.company = this.company;
    modalRef.componentInstance.group = group;
    modalRef.componentInstance.user = user;
    modalRef.componentInstance.fromCompanyDetails = true;*/
    const newG = {
      ...group,
      users: group.users.map(({ image, ...rest }) => rest)
    };
    const navigationUser: NavigationExtras = {
      state: {
        loading: false,
        company: this.company,
        department: newG,
        user: user,
        externalUser: this.user,
        fromCompanyDetails: true,
      },
    };

    this.router.navigate(["user/edit-user/", user.uuid], navigationUser);

    if (lodash.get(user, "birthdate")) {
      user.birthdate = momentTz(user.birthdate)
        .tz("Europe/Madrid")
        .format("YYYY-MM-DD");
    }
    if (lodash.get(user, "passportExpires")) {
      user.passportExpires = momentTz(user.passportExpires)
        .tz("Europe/Madrid")
        .format("YYYY-MM-DD");
    }

    /*modalRef.componentInstance.sendInfo.subscribe((userInfo) => {
      modalRef.componentInstance.loading = true;
      delete userInfo.companyUuid;
      delete userInfo.agencyUuid;
      delete userInfo.hubUuid;
      const groupRestrictionUuid = userInfo.group.uuid;
      delete userInfo.group;
      userInfo.groupRestrictionUuid = groupRestrictionUuid;
      this.userService.putUser(user.uuid, userInfo).subscribe(
        () => {
          modalRef.componentInstance.loading = false;
          modalRef.dismiss("Send Info");
          this.translate
            .get("company.company-detail.user-edit")
            .subscribe((result) => {
              this.ngxToastrService.typeSuccess(null, result);
            });
          this.loadGroups(this.company.uuid);
        },
        (err) => {
          modalRef.componentInstance.loading = false;
          this.translate
            .get("company.company-detail.error-user-edit")
            .subscribe((result) => {
              this.ngxToastrService.typeInfo(result, err.error.message);
            });
        }
      );
    });*/
  }
  

  onDeleteUser(user: User) {
    this.translate
      .get([
        "company.company-detail.remove-user",
        "company.company-detail.user-data-lost",
        "common.confirm",
        "common.cancel",
        "company.company-detail.user-removed",
        "company.company-detail.error-user-removed",
      ])
      .subscribe((result) => {
        swal
          .fire({
            title: result["company.company-detail.remove-user"],
            text: result["company.company-detail.user-data-lost"],
            showCancelButton: true,
            confirmButtonColor: "#0CC27E",
            cancelButtonColor: "#FF586B",
            confirmButtonText: result["common.confirm"],
            cancelButtonText: result["common.cancel"],
            customClass: {
              confirmButton: "swal-button-squared swal-button-confirm-green",
              cancelButton: "swal-button-squared swal-button-dismiss-red",
            },
            buttonsStyling: false,
          })
          .then((action) => {
            if (action.value) {
              this.userService.deleteUser(user.uuid).subscribe(
                () => {
                  this.ngxToastrService.typeSuccess(
                    null,
                    result["company.company-detail.user-removed"]
                  );
                  this.totalUsers = 0;
                  this.totalImages = 0;
                  this.hasNoImage = true;
                  this.allLoaded = false;
                  this.loadGroups(this.company.uuid);
                },
                (err) => {
                  this.ngxToastrService.typeInfo(
                    result["company.company-detail.error-user-removed"],
                    err.error.message
                  );
                }
              );
            }
          });
      });
  }

  onSendActivateEmail(user: User){
    this.userService.sendActivateEmail(user.uuid, this.userUuid).subscribe(res => {
      this.ngxToastrService.typeSuccess(
        null,
        this.translateService.instant('company.company-detail.user-external.email-pass')
      );
    },
    (err) => {
      this.ngxToastrService.typeInfo(
        this.translateService.instant('company.company-detail.user-external.email-pass-error'),
        err.error.message
      );
    })
}

  checkTravelAndBookDates(fte: any) {
    const travelData = this.travelUtilsService.getTravelLocalStorage();
    if (travelData) {
      let initDate = fte.departDate;
      let endDate = fte.oneWay ? fte.departDate : fte.returnDate;
      const beginDate = new Date(travelData.data.initDate).toDateString();
      const finalDate = new Date(travelData.data.endDate).toDateString();
      initDate = new Date(initDate).toDateString();
      endDate = new Date(endDate).toDateString();
      if (beginDate > initDate && finalDate < endDate) {
        this.translate
          .get(["project.error-between-dates"])
          .subscribe((result) => {
            this.ngxToastrService.typeInfo(
              "",
              result["project.error-between-dates"]
            );
          });
        return false;
      }
      return true;
    } else {
      return true;
    }
  }

  onNewCar(userUuid?) {
    localStorage.setItem("userToBook", this.utilsService.encrypt(userUuid));

    const modalRef = this.modalService.open(CarRequestComponent, {
      size: "lg",
      centered: true,
    });
    modalRef.componentInstance.isModal = true;
    modalRef.componentInstance.companyUuid = this.company.uuid;
    modalRef.componentInstance.userUuid = userUuid;

    if (userUuid) {
      modalRef.componentInstance.userUuid = userUuid;
    }
  }

  handleTravelFlow(fte: any, type: string, userUuid: string) {
    const travelData = this.travelUtilsService.getTravelLocalStorage();
    const fteData = {
      uuid:
        type === "flight"
          ? fte.entityCreated?.uuid
          : type === "train"
          ? fte.entityCreated?.uuid
          : type === "hotel"
          ? fte?.uuid
          : type === "car"
          ? fte.carCreated?.uuid
          : fte.expenseCreated?.uuid,
    };
    if (travelData) {
      if (travelData.type?.toLowerCase() === "new") {
        if (userUuid) {
          travelData.data["userUuid"] = userUuid;
          fteData["userUuid"] = userUuid;
        }
        this.travelUtilsService.createTravel(travelData.data, fteData, type);
      } else {
        const addBody = {
          item: {
            type: type,
            uuid:
              type === "flight"
                ? fte.flightCreated?.uuid
                : type === "train"
                ? fte.trainCreated?.uuid
                : type === "hotel"
                ? fte?.uuid
                : type === "car"
                ? fte.carCreated?.uuid
                : fte.expenseCreated?.uuid,
          },
        };
        this.travelUtilsService.addItemToTravel(addBody, travelData.data.uuid);
      }
    }
    this.travelUtilsService.removeTravelLocalStorage();
  }

  createCustomBooking(uuid: string) {
    const modalRef = this.modalService.open(RequestCustomHotelComponent, {
      size: "lg",
      centered: true,
      backdrop: "static",
      keyboard: false,
    });
    modalRef.componentInstance.loading = false;
    modalRef.componentInstance.userUuid = uuid;
    modalRef.componentInstance.isModal = true;

    this.subscription.push(
      modalRef.componentInstance.closeEvent.subscribe((s) => {
        modalRef.close();
      })
    );
  }

  setUserFilters(userUuid: string) {
    this.userService.getPoliciesUser(userUuid).subscribe(
      (policy: any) => {
        this.authService.userFilters = policy.filters;
      },
      (err) => {}
    );
  }

  onNewFlightTrain(type, userUuid?, manual?: boolean) {
    const decryptedUser = localStorage.getItem("userToBook") ? this.utilsService.decrypt(localStorage.getItem("userToBook")) : null
    if (decryptedUser && decryptedUser !== userUuid) {
      localStorage.removeItem('packageRateAccomInfo');
      localStorage.removeItem('packageRateFlightInfo');
      localStorage.removeItem('isPackageRate')
    }
    localStorage.setItem("userToBook", this.utilsService.encrypt(userUuid));
    this.setUserFilters(userUuid);
    if (type === "train") {
      if (manual) {
        const modalRef = this.modalService.open(FormFlightTrainComponent, {
          size: "lg",
          centered: true,
          backdrop: "static",
          keyboard: false,
        });
        modalRef.componentInstance.type = type;
        modalRef.componentInstance.isModal = true;
        modalRef.componentInstance.companyUuid = this.company.uuid;
        modalRef.componentInstance.isManual = true;

        if (userUuid) {
          modalRef.componentInstance.userUuid = userUuid;
        }
        type = "custom-train";
      } else {
        const dataFromCompany = {
          userUuid: userUuid,
          companyUuid: this.company.uuid,
          type: "train",
        };
        this.router.navigateByUrl(`${type}`, { state: { dataFromCompany } });
      }
    } else {
      if (manual) {
        const modalRef = this.modalService.open(FormFlightTrainComponent, {
          size: "lg",
          centered: true,
        });
        modalRef.componentInstance.type = type;
        modalRef.componentInstance.isModal = true;
        modalRef.componentInstance.companyUuid = this.company.uuid;
        modalRef.componentInstance.isManual = true;
        modalRef.componentInstance.userUuid = userUuid;
      } else {
        const dataFromCompany = {
          type: type,
          userUuid: userUuid,
          companyUuid: this.company.uuid,
          isModal: false,
          isManual: false,
        };

        this.router.navigateByUrl(`${type}`, { state: { dataFromCompany } });
      }
    }
  }

  getPercentages() {
    this.getConfigsubscription.push(
      this.configService.getPercentageVyoo("percentageCompany").subscribe(
        (data: Config) => {
          this.configHotels = data;
          if (!this.configHotels.value) {
            this.configHotels.value = [17];
          }
          this.maxHotelPercentage = this.configHotels.value
            ? this.configHotels.value[0]
            : 17;
        },
        (err) => {
          this.ngxToastrService.typeInfo(
            "Error",
            this.translate.instant("common.some-error")
          );
        }
      ),
      this.configService.getPercentageVyoo("flightCommissions").subscribe(
        (data: Config) => {
          this.configFlights = data;
          if (!this.configFlights.value) {
            this.configFlights.value = [
              {
                local_emission: 5,
                eu_emission: 7,
                world_emission: 9,
                percentage: 5,
              },
            ];
          }

          this.maxFlightPercentage = this.configFlights.value[0].percentage;
        },
        (err) => {
          this.ngxToastrService.typeInfo(
            "Error",
            this.translate.instant("common.some-error")
          );
        }
      )
    );
  }
  getProfile() {
    this.authService.getProfile().subscribe((res: User | Company | Agency) => {
      this.userOrEmployee = res;
      this.isGroupAdmin =
        res.type === "USER" && res.isGroupAdmin ? res.isGroupAdmin : false;
    });
  }

  editCompany(group: any) {
    const extras: NavigationExtras = {
      state: {
        loading: false,
        company: this.company,
        maxHotelPercentage: 100,
        maxFlightPercentage: 100,
      },
    };

    this.router.navigate(["/companies/edit-company/"], extras);

    /*const modalRef = this.modalService.open(CompanyFormComponent, {
      size: "lg",
      centered: true,
    });
    modalRef.componentInstance.loading = false;
    modalRef.componentInstance.company = this.company;
    modalRef.componentInstance.maxHotelPercentage = 100;
    modalRef.componentInstance.maxFlightPercentage = this.maxFlightPercentage;
    modalRef.componentInstance.sendInfo.subscribe((companyInfo) => {
      if (companyInfo) {
        modalRef.componentInstance.loading = true;
        let attributes = {};
        const general = {
          name: this.company.name,
          cif: this.company.cif,
          email: this.company.email,
          address: this.company.address,
          city: this.company.city,
          province: this.company.province,
          postalCode: this.company.postalCode,
          country: this.company.country,
          discount: this.company,
          agencyUuid: this.company?.agencyUuid,
        };
        if (this.isCompany) {
          delete general.discount;
        }
        if (!_lodash.isEqual(this.company.billingData, companyInfo.billing)) {
          attributes["billingData"] = companyInfo.billing;
        }
        if (!_lodash.isEqual(general, companyInfo.general)) {
          attributes = { ...attributes, ...companyInfo.general };
        }
        if (!_lodash.isEmpty(attributes)) {
          if (attributes["discount"]) {
            attributes["discount"] = attributes["discount"].toString();
          }
          if (attributes["flightDiscount"] >= 0) {
            attributes["flightDiscount"] =
              attributes["flightDiscount"].toString();
          }
          if (attributes["hotelComission"] >= 0) {
            attributes["hotelComission"] =
              attributes["hotelComission"].toString();
          }
          if (attributes["trainComission"] >= 0) {
            attributes["trainComission"] =
              attributes["trainComission"].toString();
          }
          const image = attributes["image"];
          delete attributes["image"];
          let formData = new FormData();
          formData = this.utilsService.toFormData(attributes, formData);
          if (image && image.name) {
            formData.append("file", image, image.name);
          }
          const putCompany = this.companyService.putCompany(
            formData,
            this.company.uuid
          );
          putCompany.subscribe(
            () => {
              modalRef.componentInstance.loading = false;
              modalRef.dismiss("Send Info");
              this.translate
                .get("company.company-homepage.card.edited-company")
                .subscribe((result) => {
                  this.ngxToastrService.typeSuccess(null, result);
                  if (this.reloadCompanies) {
                    this.reloadCompanies.emit();
                  }
                });
            },
            (err) => {
              modalRef.componentInstance.loading = false;
              this.translate
                .get("company.company-homepage.card.error-edit-company")
                .subscribe((result) => {
                  this.ngxToastrService.typeInfo(result, err.error.message);
                });
            }
          );
        } else {
          modalRef.componentInstance.loading = false;
          modalRef.close();
        }
      } else {
        this.reloadCompanies.emit();
      }
    });*/
  }

  seeReports() {
    const route =
      this.userType?.toUpperCase() === "COMPANY"
        ? "my-company/reports"
        : `companies/${this.company.uuid}/reports`;
    this.router.navigate([route]);
  }

  seeUserBooked(userId) {
    this.router.navigate(["user/booked/", userId], {
      state: { isAdmin: this.userType === "COMPANY" ? false : true },
    });
  }

  createUserBooking(userUuid) {
    const decryptedUser = localStorage.getItem("userToBook") ? this.utilsService.decrypt(localStorage.getItem("userToBook")) : null
    if (decryptedUser && decryptedUser !== userUuid) {
      localStorage.removeItem('packageRateAccomInfo');
      localStorage.removeItem('packageRateFlightInfo');
      localStorage.removeItem('isPackageRate')
    }
    localStorage.setItem("userToBook", this.utilsService.encrypt(userUuid));
    this.setUserFilters(userUuid);
    this.store.dispatch(new ResetFiltersAction());
    this.router.navigate([`search/${userUuid}`]);
  }

  onNewCustomService(groupId, userId) {
    const groupUser = this.departments.filter((group) => group.uuid === groupId)[0];
    this.authService.userFilters = groupUser.filters;
    localStorage.setItem("userToBook", this.utilsService.encrypt(userId));
    this.store.dispatch(new ResetFiltersAction());
    const navigationExtra: NavigationExtras = {
      queryParams: {
        companyUuid: this.uuid,
      },
    };
    this.router.navigate([`custom-services/${userId}`], navigationExtra);
  }

  goToDashboard(name: string, type: string, uuid: string) {
    const dataDashboard = {
      name,
      type,
      uuid,
      fromSuperAdmin: this.userType === "COMPANY" ? false : true,
      accessType: 'company'
    };
    const route =
      this.userType === "COMPANY"
        ? "my-company/dashboard"
        : `companies/${this.company.uuid}/dashboard`;
    this.router.navigateByUrl(route, { state: { dataDashboard } });
  }

  seeAuthorizations() {
    const route = !this.isAdmin
      ? "my-company/authorizations"
      : `companies/${this.company.uuid}/authorizations`;
    const navigationExtra: NavigationExtras = {
      state : { company: this.company }
    }
    this.router.navigate([route], navigationExtra);
  }

  getAuthorizationList() {
    const params = { ...this.params };

    if (this.type?.toLowerCase() === "all") {
      delete params["type"];
    }

    const companyUuid = this.route.snapshot.paramMap.get("uuid") || this.uuid;

    if ((this.isAdmin || this.isCompany) && companyUuid) {
      params["companyUuid"] = companyUuid;
    }

    this.subscription.push(
      this.bookedService.getAuthorization(params).subscribe((result) => {
        if (result && result.length > 0) {
          this.haveRequest = result.some((doc) => doc.status === "request");
          this.totalAuthorizations = result.filter(
            (doc) => doc.status === "request"
          ).length;
        } else {
          this.haveRequest = false;
          this.totalAuthorizations = 0;
        }

        this.authorizations = result;
        this.pagination = { ...result };
        delete this.pagination.docs;
      })
    );
  }

  changeActive(user: User) {
    if (this.isAdmin || this.isCompany) {
      this.userService
        .putUser(user.uuid, { dni: user.dni, active: !user.active })
        .subscribe(() => {
          this.totalUsers = 0;
          this.totalImages = 0;
          this.hasNoImage = true;
          this.allLoaded = false;
          this.loadGroups(this.company.uuid);
        });
    }
  }

  hasPdf(entity: any, type: string) {
    const hasVoucherFileUrl =
      Array.isArray(entity?.voucherFileUrl) && 
      entity?.voucherFileUrl.length > 0 &&
      entity?.voucherFileUrl.some((url) => url !== "" && url !== `/media/${type}/undefined`);
  
    const hasVoucherFile =
      Array.isArray(entity?.voucherFile) && 
      entity?.voucherFile.length > 0 &&
      entity?.voucherFile.some((file) => file?.uuid && file.uuid !== "");

    return hasVoucherFileUrl || hasVoucherFile;
  }

  onGetPDF(booked: any): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      const downloadRequests: any[] = [];
      const fileNames: string[] = [];
  
      if (booked.voucherFileUrl && Array.isArray(booked.voucherFileUrl)) {
        for (let url of booked.voucherFileUrl) {
          downloadRequests.push(this.bookedService.getBookedsPdf(url).pipe(take(1)));
          fileNames.push(url);
        }
      } else if (booked.voucherFile && Array.isArray(booked.voucherFile)) {
        for (let file of booked.voucherFile) {
          const url = `/media/${file.uuid}/custom`;
          downloadRequests.push(this.bookedService.getBookedsPdf(url).pipe(take(1)));
          fileNames.push(file.fileName || file.uuid);
        }
      } else {
        const url = booked.voucherFileUrl
          ? booked.voucherFileUrl
          : `/media/${booked["voucherFile"]?.[0]?.uuid}/custom`;
        downloadRequests.push(this.bookedService.getBookedsPdf(url).pipe(take(1)));
        fileNames.push(booked.voucherFile?.[0]?.fileName || url);
      }
  
      if (downloadRequests.length > 0) {
        this.subscription.push(
          forkJoin(downloadRequests).subscribe(
            (responses) => {
              const blobUrls = responses.map((res) => URL.createObjectURL(res));
              const modalRef = this.modalService.open(ViewPdfModalComponent, {
                size: 'lg',
                centered: true,
              });
              if (blobUrls.length > 1) {
                modalRef.componentInstance.blobUrls = blobUrls;
                modalRef.componentInstance.fileNames = fileNames;
              } else {
                modalRef.componentInstance.blobUrl = blobUrls[0];
                modalRef.componentInstance.fileName = fileNames[0];
              }
              resolve();
            },
            (error) => {
              reject(error);
            },
          )
        );
      } else {
        resolve();
      }
    });
  }

  openUserStorage(user) {
    this.userService.getUser(user.uuid).subscribe(
      (userRes) => {
        /* const dialogRef =  */ this.dialog.open(DialogUserFilesComponent, {
          height: "90vh",
          width: "90vw",
          data: { user: userRes },
          panelClass: 'files-dialog'
        });
      },
      (err) => {
        console.error(err);
      }
    );
  }

  private readAsDataURL(blob: Blob): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        if (typeof reader.result === 'string') {
          resolve(reader.result);
        } else {
          reject(new Error('Invalid result type from FileReader.'));
        }
      };
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  }

  async getUserProfilePicture(user: User) {
    try {
      if (user.image && user.image !== 'undefined') {
        const media = await this.mediaService.getMedia(user.image).toPromise();
        const base64data = await this.readAsDataURL(media);
        user.image = base64data;
        this.totalImages++;
        if (this.totalImages === this.totalUsers) {
          this.allLoaded = true;
        }
      } else {
        user.image = null;
        this.totalImages++;
      }
    } catch (error) {
      console.error('Error loading image:', error);
      user.image = null;
      this.totalImages++;
    }
  }

  getGroupAdmin(group: any) {
    const users = group.users.filter((u) => u.isGroupAdmin);
    return users;
  }

  getRequestList() {
    const param: any = { status: "active" };

    const companyUuid = this.route.snapshot.paramMap.get("uuid") || this.uuid;

    if ((this.isAdmin || this.isCompany) && companyUuid) {
      param["companyUuid"] = companyUuid;
    }

    this.subscription.push(
      this.requestService.getRequests(param).subscribe(async (result: any) => {
        this.requests = await result;
        this.totalRequests = this.requests.filter(
          (doc) => doc.status === "active"
        ).length;
      })
    );
  }

  goToRequests() {
    const route = !this.isAdmin
      ? "my-company/requests"
      : `companies/${this.company.uuid}/requests`;
    this.router.navigateByUrl(route);
  }

  adminFormFlightTrain(type: string, userUuid?: string) {
    const normalizedType = type?.trim().toLowerCase();

    if (normalizedType !== "flight" && normalizedType !== "train") {
      return;
    }

    const modalRef = this.modalService.open(CreateFlightTrainComponent, {
      size: "lg",
      centered: true,
      backdrop: "static",
      keyboard: false,
    });

    modalRef.componentInstance.isAdmin = this.isAdmin;
    modalRef.componentInstance.type = normalizedType;
    modalRef.componentInstance.loading = false;
    modalRef.componentInstance.companyUuid = this.company.uuid;

    if (userUuid) {
      modalRef.componentInstance.userId = userUuid;
    }

    modalRef.componentInstance.sendInfo.subscribe((info) => {
      modalRef.componentInstance.loading = true;

      const formData = new FormData();

      if (Array.isArray(info.file)) {
        info.file.forEach((file: any, index: number) => {
          if (file?.blob && file?.name) {
            const newFile = new File(
              [file.blob],
              file.name,
              { type: file.blob.type }
            );

            formData.append("file", newFile, newFile.name);
          } else if (file instanceof File) {
            formData.append("file", file, file.name);
          } else if (file instanceof Blob) {
            const newFile = new File(
              [file],
              `file_${index}.pdf`,
              { type: file.type }
            );

            formData.append("file", newFile, newFile.name);
          }
        });
      }

      formData.append("companyUuid", info.companyUuid);
      formData.append("userUuid", info.userId);

      formData.append(
        "departDate",
        moment(info.departure).format("YYYY-MM-DD HH:mm:ss")
      );

      formData.append("observations", info.annotations || "");
      formData.append("oneWay", String(!!info.oneWay));
      formData.append("customCode", info.customCode || "");
      formData.append("costCenter", info.costCenter || "");

      if (info.price != null) {
        formData.append("price", String(info.price));
      }

      if (info.wholesalePrice != null) {
        formData.append(
          "wholesalePrice",
          String(info.wholesalePrice)
        );
      }

      if (info.freeTaxes != null) {
        formData.append(
          "freeTaxes",
          String(info.freeTaxes)
        );
      }

      if (info.travelName) {
        formData.append("travelName", info.travelName);
      }

      if (!info.oneWay && info.return) {
        formData.append(
          "returnDate",
          moment(info.return).format("YYYY-MM-DD HH:mm:ss")
        );
      }

      if (info.traveller) {
        formData.append(
          "traveller",
          JSON.stringify(info.traveller)
        );
      }

      if (info.providerUuid) {
        formData.append("providerUuid", info.providerUuid);
      }

      if (info.supplierInvoice) {
        formData.append(
          "supplierInvoice",
          info.supplierInvoice
        );
      }

      if (info.bookType) {
        formData.append("bookType", info.bookType);
      }

      if (info.invoiced) {
        formData.append("invoiced", info.invoiced);
      }

      if (info.paymentCard) {
        formData.append(
          "paymentCard",
          JSON.stringify(info.paymentCard)
        );
      }

      if (info.pnr) {
        formData.append("pnr", info.pnr);
      }

      if (normalizedType === "flight") {
        formData.append("from", info.origin || "");
        formData.append("to", info.destination || "");

        formData.append(
          "departLocalDate",
          this.formatLocalDate(info.departure)
        );

        if (info.return && !info.oneWay) {
          formData.append(
            "returnLocalDate",
            this.formatLocalDate(info.return)
          );
        }

        formData.append("newCustom", "true");

        if (info.departureAirline) {
          formData.append(
            "departureAirline",
            info.departureAirline
          );
        }

        if (info.returnAirline && !info.oneWay) {
          formData.append(
            "returnAirline",
            info.returnAirline
          );
        }
      } else {
        const origin =
          typeof info.origin === "string"
            ? { name: info.origin.trim() }
            : info.origin;

        const destination =
          typeof info.destination === "string"
            ? { name: info.destination.trim() }
            : info.destination;

        formData.append(
          "origin",
          JSON.stringify(origin)
        );

        formData.append(
          "destination",
          JSON.stringify(destination)
        );

        formData.append("newCustom", "true");

        if (info.departureCarrier) {
          formData.append(
            "departureCarrier",
            info.departureCarrier
          );
        }

        if (info.returnCarrier && !info.oneWay) {
          formData.append(
            "returnCarrier",
            info.returnCarrier
          );
        }
      }

      if (Array.isArray(info.travellers)) {
        const travellers = info.travellers.map(
          (traveller: any) => {
            const cloned = { ...traveller };

            if (
              Array.isArray(cloned.files) &&
              cloned.files.length > 0
            ) {
              cloned.files.forEach((file: File) => {
                formData.append("file", file, file.name);
              });

              cloned.filesCount = cloned.files.length;
              delete cloned.files;
            }

            return cloned;
          }
        );

        formData.append(
          "travellers",
          JSON.stringify(travellers)
        );
      }

      const fte = {
        departDate: info.departure,
        returnDate: info.oneWay ? null : info.return,
        oneWay: info.oneWay,
      };

      if (!this.checkTravelAndBookDates(fte)) {
        modalRef.componentInstance.loading = false;
        return;
      }

      const postCreate =
        normalizedType === "train"
          ? this.trainService.postCreateTrain(formData)
          : this.flightService.postCreateFlight(formData);

      postCreate.subscribe(
        (result) => {
          modalRef.componentInstance.loading = false;
          modalRef.dismiss("Send Info");

          this.handleTravelFlow(
            result,
            normalizedType,
            userUuid
          );

          this.translate
            .get([
              "common.congrat",
              `${normalizedType}.create-${normalizedType}.created-${normalizedType}`,
            ])
            .subscribe((resp) => {
              this.ngxToastrService.typeSuccess(
                resp["common.congrat"],
                resp[
                  `${normalizedType}.create-${normalizedType}.created-${normalizedType}`
                ]
              );

              const route =
                this.utilsService.getNavigationRoute(
                  this.user,
                  this.company
                );

              if (route) {
                this.router.navigate([route]);
              }
            });
        },
        (err) => {
          modalRef.componentInstance.loading = false;

          const errorBody = err?.error || {};

          const validationErrors = Array.isArray(
            errorBody.validationErrors
          )
            ? errorBody.validationErrors
            : [];

          if (
            err.status === 422 &&
            validationErrors.length > 0
          ) {
            const validationMessage =
              this.utilsService.getValidationErrorsMessage(
                validationErrors,
                normalizedType
              );

            if (
              typeof modalRef.componentInstance
                .applyBackendValidationErrors === "function"
            ) {
              modalRef.componentInstance
                .applyBackendValidationErrors(
                  validationErrors
                );
            }

            this.ngxToastrService.typeInfo(
              "ERROR",
              validationMessage ||
                errorBody.message ||
                this.translate.instant(
                  "common.validation.form-invalid"
                ),
              10000,
              { enableHtml: true }
            );

            return;
          }

          modalRef.close();

          this.ngxToastrService.typeInfo(
            "ERROR",
            errorBody.message || errorBody.text
          );
        }
      );
    });
  }

  adminFormCreateCar(userUuid?) {
    const modalRef = this.modalService.open(CreateCarComponent, {
      size: "lg",
      centered: true,
      backdrop: "static",
      keyboard: false,
    });

    modalRef.componentInstance.isAdmin = this.isAdmin;
    modalRef.componentInstance.loading = false;
    if (userUuid) {
      modalRef.componentInstance.userId = userUuid;
    }
    modalRef.componentInstance.sendInfo.subscribe((info) => {
      modalRef.componentInstance.loading = true;
      const formData = new FormData();
      if(info.file){
        if (info.file && Array.isArray(info.file)) {
          info.file.forEach((file: any, index: number) => {
            if (file.blob && file.name) {
              const newFile = new File([file.blob], file.name, { type: file.blob.type });
              formData.append("file", newFile, newFile.name);
            } 
            else if (file instanceof File) {
              formData.append("file", file, file.name);
            } 
            else if (file instanceof Blob) {
              const newFile = new File([file], `file_${index}.pdf`, { type: file.type });
              formData.append("file", newFile, newFile.name);
            } 
          });
        } 
      }
      formData.append("userUuid", info.userUuid);
      formData.append("from", info.from);
      formData.append("to", info.to);
      formData.append("pickupPlaceFrom", info.pickupPlaceFrom);
      formData.append("pickupPlaceTo", info.pickupPlaceTo);
      formData.append("price", info.price);
      if(info.wholesalePrice) {
        formData.append("wholesalePrice", info.wholesalePrice);
      }
      formData.append("age", info.age);
      if (info.travelName) {
        formData.append("travelName", info.travelName);
      }
      formData.append("freeTaxes", info.freeTaxes);
      formData.append("departDate", info.departDate);
      formData.append("returnDate", info.returnDate);
      formData.append("providerUuid", info.providerUuid);
      formData.append("carType", info.carType);
      formData.append("newCustom", "true");
      formData.append("insuranceWithExcess", info.insuranceWithExcess);
      formData.append("comments", info.comments);
      formData.append("customCode", info.customCode);
      formData.append("costCenter", info.costCenter);
      if(info.supplierInvoice) {
        formData.append("supplierInvoice", info.supplierInvoice);
      }
      if(info.bookType) {
        formData.append("bookType", info.bookType);
      }
      if(info.invoiced) {
        formData.append("invoiced", info.invoiced);
      }
      if(info.traveller) {
        formData.append ("traveller", JSON.stringify(info.traveller));
      }
      if(info.paymentCard){
        formData.append("paymentCard", JSON.stringify(info.paymentCard));
      }
      const fte = {
        departDate: info.departDate,
        returnDate: info.returnDate,
        oneWay: false,
      };
      if (this.checkTravelAndBookDates(fte)) {
        this.subscription.push(
          this.carService.createCustomCar(formData).subscribe(
            (car) => {
              modalRef.componentInstance.loading = false;
              modalRef.dismiss("Send Info");
              this.handleTravelFlow(car, "car", userUuid);
              this.subscription.push(
                this.translate
                  .get(["car.create-car.created-car"])
                  .subscribe((result) => {
                    this.ngxToastrService.typeSuccess(
                      "",
                      result["car.create-car.created-car"]
                    );
                    modalRef.dismiss();
                    // if (this.hasPdf(car, "car")) {
                    //   this.onGetPDF(car)
                    // }
                    const route = this.utilsService.getNavigationRoute(this.user, this.company);
                    if (route) {
                      this.router.navigate([route]);
                    }
                  })
              );
            },
            (err) => {
              modalRef.componentInstance.loading = false;

              const errorBody = err?.error || {};
              const validationErrors = Array.isArray(errorBody.validationErrors)
                ? errorBody.validationErrors
                : [];

              if (err.status === 422 && validationErrors.length > 0) {
                const validationMessage = this.utilsService.getValidationErrorsMessage(
                  validationErrors,
                  'car'
                );

                if (typeof modalRef.componentInstance.applyBackendValidationErrors === 'function') {
                  modalRef.componentInstance.applyBackendValidationErrors(validationErrors);
                }

                this.ngxToastrService.typeInfo(
                  'ERROR',
                  validationMessage || errorBody.message || this.translate.instant('common.validation.form-invalid'),
                  10000,
                  { enableHtml: true }
                );

                return;
              }

              modalRef.close();

              this.ngxToastrService.typeInfo(
                'ERROR',
                errorBody.message ? errorBody.message : errorBody.text
              );
            }
          )
        );
      } else {
        modalRef.componentInstance.loading = false;
      }
    });
  }

  onNewCustomBooking(userUuid: string) {
    const uuidCompany = this.companyUuid ? this.companyUuid : this.company?.uuid
    const modalRef = this.modalService.open(CreateCustomHotelComponent, {
      size: "lg",
      centered: true,
      backdrop: "static",
      keyboard: false,
    });
    modalRef.componentInstance.userId = userUuid;
    modalRef.componentInstance.isAdmin = this.isSuperAdmin;
    modalRef.componentInstance.companyUuid = uuidCompany;
    modalRef.componentInstance.sendInfo.subscribe((info) => {
      modalRef.componentInstance.loading = true;
      const formData = new FormData();
      if(info.file){
        if (info.file && Array.isArray(info.file)) {
          info.file.forEach((file: any, index: number) => {
            if (file.blob && file.name) {
              const newFile = new File([file.blob], file.name, { type: file.blob.type });
              formData.append("file", newFile, newFile.name);
            } 
            else if (file instanceof File) {
              formData.append("file", file, file.name);
            } 
            else if (file instanceof Blob) {
              const newFile = new File([file], `file_${index}.pdf`, { type: file.type });
              formData.append("file", newFile, newFile.name);
            } 
          });
        } 
      }
      formData.append("userUuid", userUuid);
      formData.append("checkIn", info.checkIn);
      formData.append("checkOut", info.checkOut);
      if (info.price) {
        formData.append("price", info.price);
      }
      if (info.wholesalePrice) {
        formData.append("wholesalePrice", info.wholesalePrice);
      }
      formData.append("destinationName", info.city);
      formData.append("hotelName", info.hotel);
      if(info.freeTaxes){
        formData.append("freeTaxes", info.freeTaxes);
      }
      if (info.comments) {
        formData.append("comments", info.comments);
      }
      if (info.travelName) {
        formData.append("travelName", info.travelName);
      }
      formData.append("customCode", info.customCode);
      formData.append("costCenter", info.costCenter);
      if(info.supplierInvoice) {
        formData.append("supplierInvoice", info.supplierInvoice);
      }
      if(info.marketingFee) {
        formData.append("marketingFee", info.marketingFee);
      }
      if(info.bookType) {
        formData.append("bookType", info.bookType);
      }
      if(info.invoiced) {
        formData.append("invoiced", info.invoiced);
      }
      if(info.people) {
        formData.append("people", info.people);
      }
      if(info.providerUuid) {
        formData.append ("providerUuid", info.providerUuid);
      }
      if(info.holder) {
        formData.append ("holder", JSON.stringify(info.holder))
      }
      const fte = {
        departDate: info.checkIn,
        returnDate: info.checkOut,
        oneWay: false,
      };

      formData.append("newCustom", "true");
      formData.append('type', 'hotel');

      if(info.paymentCard){
        formData.append("paymentCard", JSON.stringify(info.paymentCard));
      }
      if(info.locator){
        formData.append("locator", info.locator);
      }
      if (info.rooms) {
        formData.append("rooms", info.rooms);
      }
      if (info.travelersPerRoom) {
        const formattedTravelersPerRoom = info.travelersPerRoom.map((travelers, index) => ({
          roomNumber: index + 1,
          travelers: travelers
        }));
        formData.append("travelersPerRoom", JSON.stringify(formattedTravelersPerRoom));
      }
      if (info.roomsInfo) {
        info.roomsInfo.forEach((room) => {
          if (room.files && Array.isArray(room.files)) {
            room.filesCount = room.files.length;
            room.files.forEach((file) => {
              formData.append("file", file);
            });
            delete room.files;
          }
        });
        formData.append("roomsInfo", JSON.stringify(info.roomsInfo));
      }
      if (this.checkTravelAndBookDates(fte)) {
        this.subscription.push(
          this.bookedService.createCustomBooking(formData).subscribe(
            (s) => {
              this.handleTravelFlow(s, "hotel", userUuid);
              this.subscription.push(
                this.translate
                  .get(["common.congrat", "hotel.custom.created"])
                  .subscribe((resp) => {
                    modalRef.componentInstance.loading = false;
                    this.ngxToastrService.typeSuccess(
                      resp["common.congrat"],
                      resp["hotel.create-custom.success"]
                    );
                    modalRef.close();
                    if (this.hasPdf(s, "hotel")) {
                      this.onGetPDF(s)
                    }
                    const route = this.utilsService.getNavigationRoute(this.user, this.company);
                    if (route) {
                      this.router.navigate([route]);
                    }
                  })
              );
            },
            (err) => {
              modalRef.componentInstance.loading = false;

              const errorBody = err?.error || {};
              const validationErrors = Array.isArray(errorBody.validationErrors)
                ? errorBody.validationErrors
                : [];

              if (err.status === 422 && validationErrors.length > 0) {
                const validationMessage = this.utilsService.getValidationErrorsMessage(
                  validationErrors,
                  'hotel'
                );

                if (typeof modalRef.componentInstance.applyBackendValidationErrors === 'function') {
                  modalRef.componentInstance.applyBackendValidationErrors(validationErrors);
                }

                this.ngxToastrService.typeInfo(
                  'ERROR',
                  validationMessage || errorBody.message || this.translate.instant('common.validation.form-invalid'),
                  10000,
                  { enableHtml: true }
                );

                return;
              }

              modalRef.close();

              this.ngxToastrService.typeInfo(
                "ERROR",
                errorBody.message ? errorBody.message : errorBody.text
              );
            }
          )
        );
      } else {
        modalRef.componentInstance.loading = false;
      }
    });
  }

  areMoreUserOnGroup(group: any) {
    // Lista administradores
    const admins = this.getGroupAdmin(group);
    // Tengo que ver que la lista de usuario contenga algun usuario que no esté en admin
    const res = group.users.filter((user) => {
      if (!admins.includes(user)) {
        return true;
      }
    });
    return res.length > 0;
  }

  canRequestAirbnb(group: any) {
    return (
      group.filters.lodgingType === "all" ||
      group.filters.lodgingType === "room"
    );
  }

  toggleContent() {
    this.showContent = !this.showContent;
  }

  adminFormCreateAirbnb(userUuid: string, userFilters: any) {
    const type = "airbnb";
    const modalRef = this.modalService.open(CreateAirbnbComponent, {
      size: "lg",
      centered: true,
    });
    modalRef.componentInstance.isAdmin = this.isAdmin;
    modalRef.componentInstance.loading = false;
    modalRef.componentInstance.companyUuid = this.company.uuid;
    if (userUuid) {
      modalRef.componentInstance.userId = userUuid;
    }
    modalRef.componentInstance.filters = userFilters;
    modalRef.componentInstance.sendInfo.subscribe((info) => {
      modalRef.componentInstance.loading = true;
      const formData = new FormData();
      if(info.file){
        if (info.file && Array.isArray(info.file)) {
          info.file.forEach((file: any, index: number) => {
            if (file.blob && file.name) {
              const newFile = new File([file.blob], file.name, { type: file.blob.type });
              formData.append("file", newFile, newFile.name);
            } 
            else if (file instanceof File) {
              formData.append("file", file, file.name);
            } 
            else if (file instanceof Blob) {
              const newFile = new File([file], `file_${index}.pdf`, { type: file.type });
              formData.append("file", newFile, newFile.name);
            } 
          });
        } 
      }
      formData.append("companyUuid", info.companyUuid);
      formData.append("userUuid", info.userId);
      formData.append("city", info.city);
      formData.append("link", info.link);
      formData.append("checkIn", info.checkIn);
      formData.append("checkOut", info.checkOut);
      formData.append("observations", info.annotations);
      formData.append("price", info.price);
      formData.append("freeTaxes", info.freeTaxes);
      if(info.marketingFee) {
        formData.append("marketingFee", info.marketingFee);
      }
      if (info.wholesalePrice) {
        formData.append("wholesalePrice", info.wholesalePrice);
      }
      if(info.supplierInvoice) {
        formData.append("supplierInvoice", info.supplierInvoice);
      }
      if(info.bookType) {
        formData.append("bookType", info.bookType);
      }
      if(info.invoiced) {
        formData.append("invoiced", info.invoiced);
      }
      if (info.travelName) {
        formData.append("travelName", info.travelName);
      }
      if(info.paymentCard){
        formData.append("paymentCard", JSON.stringify(info.paymentCard));
      }
      if(info.providerUuid) {
        formData.append ("providerUuid", info.providerUuid);
      }
      formData.append("customCode", info.customCode);
      formData.append("costCenter", info.costCenter);
      const fte = {
        checkIn: info.checkIn,
        returnDate: info.checkOut,
        oneWay: false,
      };
      if (this.checkTravelAndBookDates(fte)) {
        const postCreate = this.airbnbService.createCustomAirbnb(formData);
        postCreate.subscribe(
          (result) => {
            modalRef.componentInstance.loading = false;
            modalRef.dismiss("Send Info");
            this.handleTravelFlow(result, type, userUuid);
            this.translate
              .get(["common.congrat", `${type}.create-${type}.created-${type}`])
              .subscribe((resp) => {
                this.ngxToastrService.typeSuccess(
                  resp["common.congrat"],
                  resp[`${type}.create-${type}.created-${type}`]
                );
                if (result.entityCreated) {
                  this.onGetPDF(result.entityCreated);
                }
                const route = this.utilsService.getNavigationRoute(this.user, this.company);
                if (route) {
                  this.router.navigate([route]);
                }
              });
          },
          (err) => {
            modalRef.componentInstance.loading = false;

            const errorBody = err?.error || {};
            const validationErrors = Array.isArray(errorBody.validationErrors)
              ? errorBody.validationErrors
              : [];

            if (err.status === 422 && validationErrors.length > 0) {
              const validationMessage = this.utilsService.getValidationErrorsMessage(
                validationErrors,
                'airbnb'
              );

              if (typeof modalRef.componentInstance.applyBackendValidationErrors === 'function') {
                modalRef.componentInstance.applyBackendValidationErrors(validationErrors);
              }

              this.ngxToastrService.typeInfo(
                'ERROR',
                validationMessage || errorBody.message || this.translate.instant('common.validation.form-invalid'),
                10000,
                { enableHtml: true }
              );

              return;
            }

            this.ngxToastrService.typeInfo(
              'ERROR',
              errorBody.message || errorBody.text || this.translate.instant('common.some-error')
            );
          }
        );
      } else {
        modalRef.componentInstance.loading = false;
      }
    });
  }

  onPolicies() {
    const companyUuid = this.companyUuid ?? this.company.uuid;
    this.companyService.getPoliciesCompany(companyUuid).subscribe((policies) => {

    const modalRef = this.modalService.open(PoliciesModalComponent, {
      size: "md",
      centered: true,
      backdrop: 'static',
      keyboard: false,
    });

    modalRef.componentInstance.company = this.company;
    modalRef.componentInstance.policies = policies;
    modalRef.result.then((result) => {
      if (result?.deleted) {
        this.loadGroups(this.company.uuid);
      }
    }).catch(() => {});
    })
  }

  goToProjects() {
    const route =
    this.userType?.toUpperCase() === "COMPANY"
      ? "my-company/projects"
      : `companies/${this.company.uuid}/projects`;
    this.router.navigate([route]);
  }

  goToBookings() {
    const route =
      this.userType?.toUpperCase() === "COMPANY"
        ? "my-company/bookings"
        : `companies/${this.company.uuid}/bookings`;
    this.router.navigate([route]);
  }

  formatLocalDate(d: any): string {
    const m = moment.isMoment(d) ? d.clone() : moment(d);
    return m.seconds(0).milliseconds(0).format('YYYY-MM-DD[T]HH:mm:ss');
  }

}
